export default __webpack_public_path__ + "static/media/Mirrored-Glass-Truck-Hero-960px-320px.22470946.jpg";